export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T>(
  path: string,
  options: { method?: string; body?: unknown } = {},
): Promise<T> {
  const res = await fetch(`/api/v1${path}`, {
    method: options.method ?? 'GET',
    credentials: 'same-origin',
    headers: {
      ...(options.body !== undefined ? { 'content-type': 'application/json' } : {}),
      'x-requested-with': 'fetch',
    },
    body: options.body !== undefined ? JSON.stringify(options.body) : null,
  });

  if (res.status === 401 && !path.startsWith('/auth/')) {
    window.location.assign('/login');
    throw new ApiError(401, 'session expired');
  }

  const text = await res.text();
  const json: unknown = text ? JSON.parse(text) : null;
  if (!res.ok) {
    const message =
      json && typeof json === 'object' && 'message' in json
        ? String((json as { message: unknown }).message)
        : res.statusText;
    throw new ApiError(res.status, message);
  }
  return json as T;
}
